import { buildSupervisorioTourSteps, restoreSupervisorioTourLayout } from './supervisorioTourSteps'

const buildSupervisorioTourStepsComplete = (tourManager) => {
    tourManager.setTourCleanup(() => restoreSupervisorioTourLayout())

    return [
        {
            popover: {
                title: 'Supervisório',
                description: 'O Supervisório permite montar uma tela personalizada para acompanhar os dados dos seus monitorados. Você escolhe quais informações deseja exibir e organiza os componentes da forma mais útil para a sua operação.<br><br>Este guia mostra como criar um painel, adicionar um componente de <strong>Valor Atual</strong> e organizar esse componente na tela.<br><br>O exemplo usado no guia é apenas ilustrativo e não será salvo.',
                side: 'over',
                align: 'center',
            },
        },
        ...buildSupervisorioTourSteps(tourManager),
    ]
}

export default buildSupervisorioTourStepsComplete
